import { BusinessController, SettingsController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import constant from '../../utils/constant';
import { useStores } from '../../stores';
import React, { useState } from 'react';
import { SignUp } from '../../pages';
import * as yup from 'yup';
import { passwordRegex, phoneRegExp } from '../../utils/utils';

const SignUpContainer = () => {
	const [step, setStep] = useState('stepOne');

	const stepOne = () => {
		setStep('stepOne');
	};

	const stepTwo = () => {
		setStep('stepTwo');
	};

	const { userStore } = useStores();

	const [hasReferral, setHasReferral] = useState(false);
	const [loading, setLoading] = useState(false);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const referrerCode = searchParams.get('referrerCode');

	const refInputHandler = () => {
		setHasReferral(true);
	};

	const switchToLogin = () => {
		navigate(constant.Routes.Login);
	};

	const testerArrays = [
		'mailinator',
		'testmail',
		'mailtrap',
		'mailcheck',
		'qa',
	];

	const validationSchema = () =>
		yup.object({
			fullname: yup
				.string()
				.required('Full Name is required')
				.test('fullName', 'First and Last name is required', function (value) {
					const names = value ? value.split(' ') : [];
					return names.length > 1 && names[0].length > 1 && names[1].length > 1;
				}),
			businessname: yup.string().required('Business name is required'),
			businessphonenumber: yup
				.string()
				.matches(phoneRegExp, 'Phone number is not valid')
				.required('Business Phone number is required'),
			businessemail: yup
				.string()
				.trim()
				.email('Enter a valid Email')
				.test('email-not-tester', 'Please provide a valid email.', value => {
					const lowercaseValue = value.toLowerCase();
					if (
						testerArrays.some(testerString =>
							lowercaseValue.includes(testerString.toLowerCase())
						)
					) {
						return false;
					}
					return true;
				})
				.required('Business Email Address is required'),

			referredBy: yup.string().optional(),
			password: yup
				.string()
				.matches(
					passwordRegex,
					'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character'
				),
			referralSource: yup
				.string()
				.required('Please select how you heard about mima'),
			businessRegNum: yup
				.string()
				.test(
					'oneRequired',
					'Please enter either your business registration number, website address, twitter handle or instagram handle',
					function () {
						return (
							this.parent.twitterHandle ||
							this.parent.instagramHandle ||
							this.parent.website ||
							this.parent.businessRegNum
						);
					}
				),
			website: yup
				.string()
				.matches(
					/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm,
					'Please enter a correct website address'
				)
				.test(
					'oneRequired',
					'Please enter either your business registration number, website address, twitter handle or instagram handle',
					function () {
						return (
							this.parent.twitterHandle ||
							this.parent.instagramHandle ||
							this.parent.website ||
							this.parent.businessRegNum
						);
					}
				),
			twitterHandle: yup
				.string()
				.test(
					'oneRequired',
					'Please enter either your business registration number, website address, twitter handle or instagram handle',
					function () {
						return (
							this.parent.twitterHandle ||
							this.parent.instagramHandle ||
							this.parent.website ||
							this.parent.businessRegNum
						);
					}
				),
			instagramHandle: yup
				.string()
				.test(
					'oneRequired',
					'Please enter either your business registration number, website address, twitter handle or instagram handle',
					function () {
						return (
							this.parent.twitterHandle ||
							this.parent.instagramHandle ||
							this.parent.website ||
							this.parent.businessRegNum
						);
					}
				),
		});

	const onSubmit = async values => {
		setLoading(true);
		const names = values.fullname.split(' ');

		const payload = {
			email: values.businessemail,
			firstname: names[0],
			lastname: names.length > 2 ? names[2] : names[1],
			middlename: names.length > 2 ? names[1] : '',
			tradingName: values.businessname,
			password: values.password,
			mobile: values.businessphonenumber,
			...(values.businessRegNum && { businessRegNum: values.businessRegNum }),
			...(values.twitterHandle && { twitterHandle: values.twitterHandle }),
			...(values.instagramHandle && {
				instagramHandle: values.instagramHandle,
			}),
			...(values.website && { website: values.website }),
			referralSource: values.referralSource,
			// "firebaseToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
		};

		if (values.referredBy || referrerCode) {
			payload.referredBy = values.referredBy || referrerCode;
		}

		const { status, errorMessage } =
			await BusinessController.signUpBusiness(payload);

		if (status === constant.Success) {
			await SettingsController.runNoAuthSetup();
			localStorage.setItem(
				constant.RouteParams,
				JSON.stringify({
					OtpType: constant.OtpType.ONBOARDING,
					userId: userStore.userId,
				})
			);
			setLoading(false);
			return navigate(constant.Routes.Otp, {
				OtpType: constant.OtpType.ONBOARDING,
				userId: userStore.userId,
			});
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	return (
		<div>
			<SignUp
				refInputHandler={refInputHandler}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				hasReferral={hasReferral}
				loading={loading}
				switchToLogin={switchToLogin}
				referrerCode={referrerCode}
				step={step}
				stepOne={stepOne}
				stepTwo={stepTwo}
			/>
		</div>
	);
};
export default SignUpContainer;
